import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@/components/primitives/Button.jsx';
import Dialog from '@/components/patterns/Dialog.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import removeConnection from '@/redux/actions/pieveActions/removeConnection.js';

/** Confirms removing a connection and says what stops working. */
const RemoveConnectionDialog = ({ connection, open, onOpenChange }) => {
  const dispatch = useDispatch();
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState('');
  const name = connection?.meta?.label || connection?.appName;

  const handleRemove = async () => {
    setIsRemoving(true);
    setError('');
    const res = await dispatch(removeConnection({ connection }));
    setIsRemoving(false);

    if (res?.success === false) {
      setError(res.message || 'The connection could not be removed.');
      return;
    }

    toastManager.add({ type: 'success', title: `${name} removed` });
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Remove ${name}?`}
      description={`Pieve loses access to this ${connection?.appName} account right away. Automations that use it stop until you connect it again.`}
      footer={
        <>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleRemove} loading={isRemoving}>
            Remove connection
          </Button>
        </>
      }>
      {error && <p className="connections-error">{error}</p>}
    </Dialog>
  );
};

export default RemoveConnectionDialog;
